module.exports = __webpack_public_path__ + "media/site/images/tatralife-screen@2x-36d8610fd99e3e217ce55ca1d9c44c74.jpg";